import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { getAccessToken } from "./localStorageServices";


export const _getBaseUrl = () => {
  return "https://cgx-stage.competencygenie.ai";
};

const apiEndpoint = _getBaseUrl();

const apiClient = axios.create({
  baseURL: apiEndpoint,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use((config) => {
  const token = getAccessToken();
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const _get = <T>(
  url: string,
  config: AxiosRequestConfig = {}
): Promise<AxiosResponse<T>> => apiClient.get<T>(url, config);

const _post = <T, D = any>(
  url: string,
  data?: D,
  config: AxiosRequestConfig = {}
): Promise<AxiosResponse<T>> => apiClient.post<T>(url, data, config);

const _put = <T, D = any>(
  url: string,
  data?: D,
  config: AxiosRequestConfig = {}
): Promise<AxiosResponse<T>> => apiClient.put<T>(url, data, config);

const _delete = <T>(
  url: string,
  config: AxiosRequestConfig = {}
): Promise<AxiosResponse<T>> => apiClient.delete<T>(url, config);

export { _get, _post, _put, _delete, apiClient };
